import React, {useState} from 'react';
import {UploadOutlined, DownloadOutlined} from '@ant-design/icons';
import {Upload, Input, Button, Divider, Typography} from 'antd';
import {withFormsy} from "formsy-react";

const {Text} = Typography;
const {TextArea} = Input;
const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
const { Dragger } = Upload;
const MAX_SIZE = 25 * 1024 * 1024 // 25MB in bytes

const MultiDocUpload = (props) => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [preview, setPreview] = useState(null);

    // const fileList = useMemo(() => {
    //     return TB.map(props.getValue() || [], file => {
    //         let formatted = TB.clone(file);
    //         if (formatted.path) {
    //             formatted.url = formatted.path;
    //         }
    //         return formatted;
    //     })
    // }, [props.getValue() || []]);
    const handleCancel = async () => {
        await setPreviewOpen(false);
        setPreview(null)
    };

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        await setPreview(file);
        setPreviewOpen(true);
        // setPreviewTitle(file.caption || file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
    };
    // const handleChange = ({fileList: newFileList}) => props.setValue(newFileList);
    const onChange = async ({file, fileList}) => {

        await TB.map(fileList, async (item, index) => {

            if (!item.id) {
                if (!item.caption && item.name?.length) {
                    item.caption = TB.titleCase(item.name.replace(/\.[^/.]+$/, ""));
                }
                if (item.mimetype?.includes('pdf')) {
                    item.content_type = 'PDF'
                }else {
                    item.content_type = 'Document';
                }

                item.display_index = index + 1;

                if (!item.path && item?.response?.success?.data?.file_path) {
                    item.path = item?.response?.success?.data?.file_path;
                    item.url = item?.response?.success?.data?.url;
                }
            }
        })

        TB.map(fileList, (item, index) => {
            if (item.size > MAX_SIZE) {
                fileList.splice(index, 1);
            }
        })

        props.setValue(fileList)
    }
    const onRemove = (file) => {
        const index = (props.getValue() || []).indexOf(file);
        let updatedFileList = TB.clone(props.getValue() || [])
        const newFileList = updatedFileList.slice();
        newFileList.splice(index, 1);
        props.setValue(newFileList);
    }
    const errorMessage = (props.showError() || props.isFormSubmitted()) && props.getErrorMessage();

    let className = props.showRequired() ? 'required ' : '';

    className += (!props.isValid() && props.isFormSubmitted()) ? ' text-danger is-invalid ' : '';



    return (
        <div className={"multi-asset-upload transition-all ease-in flex flex-col form-group " + className + " " + props.className}>
            {props.label && (
                <label className={`col-form-label flex flex-row items-center ${props.labelClassName || ''}`}>
                    <span>{props.label}</span>
                    {props.required && <span className="required-symbol"> *</span>}
                    {props.getValue()?.length > 0 && (
                        <span className={TB.mapClass("ml-auto text-xxs italic", {
                            "opacity-7": props.getValue()?.length < props.maxCount,
                            "text-danger font-semibold opacity-1": props.getValue()?.length === props.maxCount,
                        })}>
                            Max ({props.getValue()?.length} / {props.maxCount})
                        </span>
                    )}
                </label>
            )}

            <div className="">
                <Upload
                    name={'file'}
                    multiple
                    onRemove={onRemove}
                    onChange={onChange}
                    action="/api/assets/upload"
                    data={(file) => {
                        // Change request params
                        return {file: file}
                    }}
                    beforeUpload={(file, FileList) => {
                        if (file.size > MAX_SIZE) {
                            TB.toast(`Max upload size is 25MB`, {theme: 'danger'})
                            return false;
                        }
                    }}
                    accept={props.accept + (props.mime ? `,${props.mime}` : '')}
                    maxCount={props.maxCount || 10}
                    fileList={props.getValue() || []}
                    showUploadList={{
                        showRemoveIcon: !props.disabled,
                        showDownloadIcon: !props.disabled,
                        downloadIcon: file => {
                            return file.url ? <DownloadOutlined/> : <></>
                        }
                    }}
                >
                    {!props.disabled && (props.getValue() || []).length < (props.maxCount || 10) && (
                        <React.Fragment>
                            <Button icon={<UploadOutlined/>}>Select Documents</Button>
                            {props.getValue()?.length > 0 && <Divider className="my-2.5"/>}
                        </React.Fragment>
                    )}
                </Upload>
            </div>
            {props.accept && (
                <Text type="secondary" className="text-xs italic mt-4">Accepted File Types: {TB.replace(props.accept, /,(?!\s)/g, ', ')}</Text>
            )}
            <div className="invalid-feedback block transition-all ease-in"
                 style={errorMessage ? {opacity: 1, height: 20, ...(props.invalidStyles || {})} : {
                     opacity: 0,
                     height: 0
                 }}>
                {errorMessage}
            </div>

        </div>
    )

};

export default withFormsy(MultiDocUpload)